__turbopack_context__.v({
  "className": "ready_edaaa661-module__cQv1xa__className",
  "variable": "ready_edaaa661-module__cQv1xa__variable",
});
